ace.define("ace/snippets/mysql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="mysql"})


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/ace-builds/src-min-noconflict/snippets/mysql.js
// module id = 1749
// module chunks = 3